/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { Image as NativeImage, Box, IImageProps, IBoxProps } from 'native-base';
import { activateChangeEnv, useQaAgent, useSpringBigStore } from '@springbig/shared';

import { Caption, Txt } from './Typography';
import { useAppNavigate } from '~/pages';
import Pressable from './Pressable';

export interface ImageProps extends IImageProps {
    uri?: string;
    containerProps?: IBoxProps
    hideTextVariant?: boolean
}

const Image = ({ uri, ...props }: ImageProps) => {

    return (
        <Box {...props.containerProps}>{uri && <NativeImage alt={props.alt || 'Alternate Text'}
            source={{ uri: `${uri}` }} {...props} />}</Box>
    );
};

const useDevActions = () => {

    const { navigate } = useAppNavigate();
    const { isQaAgent } = useQaAgent();


    const onPress = () => {

        if (isQaAgent) {

            navigate('auth/select-env');
            return;
        }

        navigate('auth/secret-pin');
    };

    // return onPress;
    return () => activateChangeEnv(onPress);
};

const LogoImage = ({ ...props }: ImageProps) => {

    const onPress = useDevActions();
    const { isQaAgent } = useQaAgent();
    const { apiEnv } = useSpringBigStore();

    let stage: null | React.ReactNode = null;

    if (isQaAgent) {
        stage = (
            <Box
                bg='background'
                position={'absolute'}
                bottom={'-5'}
                right={'-10'}
                py={0}
                px={0.5}
                zIndex={99}
            ><Txt fontSize={10} color={'primary'}>{apiEnv}</Txt></Box>
        );
    }

    return (
        <Pressable
            onPress={onPress}
        >
            {stage}
            <NativeImage {...props} />
        </Pressable>
    );
};

export const Logo2xl = ({ ...props }: ImageProps) => {

    const { fullLogo, member } = useSpringBigStore();

    if (fullLogo) {
        return <LogoImage
            alt={member?.merchant_name}
            resizeMode="contain"
            w={160}
            h={160}
            src={fullLogo}
            {...props}
        />;
    }

    if (props.hideTextVariant === false || props.hideTextVariant === undefined) {
        return <Caption>{member?.merchant_name}</Caption>;
    }
};

export const LogoXl = ({ ...props }: ImageProps) => {

    const { fullLogo, member } = useSpringBigStore();

    if (fullLogo) {
        return (
            <LogoImage
                alt={member?.merchant_name}
                resizeMode="contain"
                w={60}
                h={60}
                src={fullLogo}
                {...props}
            />
        );
    }

    return <Caption>{member?.merchant_name}</Caption>;
};

export const LogoLg = ({ ...props }: ImageProps) => {

    const { fullLogo, member } = useSpringBigStore();

    if (fullLogo) {
        return (
            <LogoImage
                src={fullLogo}
                alt={member?.merchant_name}
                resizeMode="contain"
                w={70}
                h={50}
                {...props}
            />
        );
    }

    return <Caption>{member?.merchant_name}</Caption>;
};

export const LogoMd = ({ ...props }: ImageProps) => {

    const { navLogo, member } = useSpringBigStore();

    if (navLogo) {
        return (
            <NativeImage
                src={navLogo}
                alt={member?.merchant_name}
                w={45}
                h={25}
                {...props}
            />
        );
    }

    return <Caption>{member?.merchant_name}</Caption>;
};

export const LogoSm = ({ ...props }: ImageProps) => {

    const { fullLogo, member } = useSpringBigStore();

    if (fullLogo) {
        return (
            <LogoImage
                src={fullLogo}
                alt={member?.merchant_name}
                w={35}
                h={18}
                {...props}
            />
        );
    }

    return <Caption>{member?.merchant_name}</Caption>;
};

export default Image;
